
import {
  Settings,
  LogOut,
  User,
  CreditCard,
  Mail,
  MessageSquare,
  PlusCircle,
  Plus,
  Bell,
  CheckSquare,
  Calendar,
  LineChart,
  BarChart2,
  Users,
  Home,
  Send,
  Zap,
  DollarSign,
  Pencil,
  Trash2,
  Edit,
  CircleCheck,
  CircleAlert,
  Clock,
  Loader2,
  UserPlus,
  List,
  LayoutGrid,
  AlertTriangle,
  Check,
} from "lucide-react";

export const Icons = {
  logo: User,
  settings: Settings,
  logout: LogOut,
  creditCard: CreditCard,
  mail: Mail,
  message: MessageSquare,
  plusCircle: PlusCircle,
  plus: Plus,
  notification: Bell,
  check: Check,
  calendar: Calendar,
  chart: LineChart,
  barChart: BarChart2,
  users: Users,
  home: Home,
  send: Send,
  automation: Zap,
  finances: DollarSign,
  pencil: Pencil,
  trash: Trash2,
  edit: Edit,
  success: CircleCheck,
  warning: CircleAlert,
  clock: Clock,
  loader: Loader2,
  userPlus: UserPlus,
  list: List,
  layoutGrid: LayoutGrid,
  alertTriangle: AlertTriangle,
};
